export default __webpack_public_path__ + "static/media/ico_hood_online.ed62006a.svg";